module.exports = __webpack_public_path__ + "img/step2_3.425c6b54.jpg";